<template>
  <div>
    <div class=" mainLoader" v-if="loading">
    </div>
    <div class="col-md-12 recruit-detail-image">
    </div>
    <div class="realbody">
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-12">
            <div class="mt-5">
            </div>
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-7">
                   <div class="row" >
                    <div class="col-md-3 text-center">
                      <video v-if="engineer_video"   height="125" width="125" controls autoplay loop>
                        <source :src="engineer_video">
                      </video>

                      <img v-if="engineer_image" class="rounded-circle" style="width: 125px; height:125px;" :src="engineer_image" />

                    </div>
                    <div class="col-md-8">
                      <div class="row" style="margin-top: 3.5rem">
                          <p class="rc_firsttitle mplus2p-m spacing1-2 noiseblack" >{{engineer_initials}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-5 mt-5" v-if="!testUser">
                       <button v-if="engineer_favorited" class="btn whitebtn clickcbtn like" @click="onFavClick(engineer_id)" style="margin-right: 10px;">
                        <i class="fa fa-heart margin-r-5"></i>
                      </button>
                      <button v-if="!engineer_favorited" class="btn whitebtn clickcbtn" @click="onFavClick(engineer_id)" style="margin-right: 10px;">
                        <i class="fa fa-heart margin-r-5"></i>
                      </button>
                        <button v-if="engineer_verified != 0" class="btn whitebtn clickcbtn"  @click="sandMsg(engineer_id)" style="margin-right: 10px;">
                          <i class="fa fa-envelope margin-r-5"></i>
                        </button><div v-if="engineer_want_to_talk_casually" class="casually">{{$t('speech_bubble')}}</div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div v-if="engineer_manager_comments" class="comment-block">
                  <p class="comment-title">{{$t('comments_manager')}}</p>
                  <p class="comment-desc">{{engineer_manager_comments}}</p>
                </div>
              </div>
            </div>
            <div  v-if="engineer_last_login" class="col-md-12 mb-5 mt-4">
              <div class="row float-right">
                  <div>
                      {{$t('last_login_time')}} : {{dateFormate(engineer_last_login)}}
                  </div>
              </div>
              </div>
            <div class="row slide_options">
              <div class="col-md-6 slide_item spressed wrapper1 " id="s1" @click="pressed_slide(1)">
                <span class="slide_txt mplus2p-r spacing1-4">{{$t('e_profile')}}</span>
              </div>
              <div class="col-md-6 slide_item wrapper1" id="s2" @click="pressed_slide(2)">
                <span class="slide_txt mplus2p-r spacing1-4">{{$t('e_score')}}</span>
              </div>
            </div>
             <div class="container">
              <div class="row pview " id="basic_info">
                <div class="col-md-12" style="height: 30px;"></div>
                <template v-if="enginner_job_seeking">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_job_seeking')}}</p>
                  </div>
                  <div v-if="enginner_job_seeking != null " class="col-md-8">
                    <p v-if="lan == 'en'" class="mplus2p-m spacing1-2 noiseblack">{{enginner_job_seeking.en_situation}}</p>
                    <p v-if="lan == 'jp'" class="mplus2p-m spacing1-2 noiseblack">{{enginner_job_seeking.jp_situation}}</p>
                  </div>
                </template>

                <div class="col-md-12" style="height: 30px;"></div>
                <template v-if="engineer_expertise">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t(' expertise ')}}</p>
                  </div>
                  <div v-if="engineer_expertise != null " class="col-md-8">
                    <p v-if="lan == 'en'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_expertise.en_expertise}}</p>
                    <p v-if="lan == 'jp'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_expertise.jp_expertise}}</p>
                  </div>
                </template>
                <template v-if="engineer_desc">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack" style="margin-top: 17.5px;">
                      {{$t('ep_basic_info')}}</p>
                  </div>
                  <div class="col-md-8">
                    <pre class="cs_summary mplus2p-m spacing1-2 noiseblack" style="height:auto;white-space:pre-wrap;" v-html="urlify(engineer_desc)"></pre>
                  </div>
                </template>
                <!-- <template v-if="engineer_email">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('r_email')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">{{engineer_email}}</p>
                  </div>
                </template> -->
                <template v-if="engineer_bday">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_age')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">{{engineer_bday}}</p>
                  </div>
                </template>
                <template v-if="engineer_sex">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_sex')}}</p>
                  </div>
                  <div v-if="engineer_sex != ''" class="col-md-8">
                    <p v-if="lan == 'en'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_sex.en_gender}}</p>
                    <p v-if="lan == 'jp'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_sex.jp_gender}}</p>
                  </div>
                </template>
                <template v-if="engineer_location">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_location')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p v-if="lan == 'en'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_location.en_location}}</p>
                    <p v-if="lan == 'jp'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_location.jp_location}}</p>
                  </div>
                </template>
                <template v-if="engineer_national">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_national')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p v-if="lan == 'en'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_national.en_national}}</p>
                    <p v-if="lan == 'jp'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_national.jp_national}}</p>
                  </div>
                </template>
                <template v-if="Array.isArray(engineer_languages) && engineer_languages.length > 0">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_languages')}}</p>
                  </div>
                  <div class="col-md-8">
                    <div class="tech2">
                      <span class="layer2" v-for="(item, index) of engineer_languages" :key="index">{{ lan == 'en'? item.en_language:item.jp_language}}</span>
                    </div>
                  </div>
                </template>
                <template v-if="engineer_required_position.length > 0">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_required_position')}}</p>
                  </div>
                  <div class="col-md-8">
                     <div class="tech2">
                      <span class="layer2" v-for="(item, index) of engineer_required_position" :key="index">{{ lan == 'en'? item.en_required_position:item.jp_required_position}}</span>
                    </div>
                  </div>
                </template>
                <template v-if="Array.isArray(engineer_requried_type_of_contract) && engineer_requried_type_of_contract.length > 0">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">
                      {{$t('ep_requried_type_of_contract')}}</p>
                  </div>
                  <div class="col-md-8">
                    <div class="tech2">
                      <span class="layer2" v-for="(item, index) of engineer_requried_type_of_contract" :key="index">{{ lan == 'en'? item.en_required_type:item.jp_required_type}}</span>
                    </div>
                  </div>
                </template>
                <template v-if="Array.isArray(engineer_required_work_area_to_be) && engineer_required_work_area_to_be.length > 0">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">
                      {{$t('ep_required_work_area_to_be')}}</p>
                  </div>
                  <div class="col-md-8">
                    <div class="tech2">
                      <span class="layer2" v-for="(item, index) of engineer_required_work_area_to_be" :key="index">{{ lan == 'en'? item.en_work_area:item.jp_work_area}}</span>
                    </div>
                  </div>
                </template>

                 <template v-if="engineer_income_type && engineer_income != 0">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_desired')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">
                        {{ lan == 'en' ?  engineer_income_type.en_type : engineer_income_type.jp_type}}
                        <b>{{engineer_income}}</b>
                        {{$t('ep_currency_unit')}}
                    </p>
                  </div>
                </template>

                <template v-if="engineer_policy">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_policy')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">{{engineer_policy}}</p>
                  </div>
                </template>
                <template v-if="engineer_experience">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_experience')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">
                      {{lan == 'en' ? engineer_experience.en_experience : engineer_experience.jp_experience}}
                    </p>
                  </div>
                </template>
                <template v-if="engineer_pdf.length > 0">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('e_resumes')}}</p>
                  </div>
                  <div 
                      class="col-md-8 text-primary cursor"
                    >
                    <div  v-for="(pdf,index) of engineer_pdf" :key="index">
                      <a href="javascript:void(0)" @click="downloadFile(pdf.file_path)">
                      <strong>{{ pdf.file_path }}</strong>
                    </a>
                    </div>
                    </div>
                </template>
                <template v-if="engineer_current_position">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_current_position')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">
                      {{lan == 'en' ? engineer_current_position.en_required_position : engineer_current_position.jp_required_position}}</p>
                  </div>
                </template>
                <template v-if="engineer_current_type_of_contract != null">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">
                      {{$t('ep_current_type_of_contract')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">
                      {{lan == 'en' ? engineer_current_type_of_contract.en_required_type : engineer_current_type_of_contract.jp_required_type}}</p>
                  </div>
                </template>

                <template v-if="engineer_past_job_details.length > 0">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_past_job_details')}}</p>
                  </div>
                  <div class="col-md-8">
                    <div v-for="(item, index) in engineer_past_job_details" :key="index">
                        <div class="jobDetail">
                          <div class="col-md-12 pt-2 ml-2 pl-3 mb-2">
                             <p  style="text-transform: capitalize" class="p-0 mb-1 mplus2p-m spacing1-2 noiseblack">{{item.experienced_corporate ? lan == 'en' ? item.experienced_corporate.en_corporate : item.experienced_corporate.jp_corporate : ''}}</p>
                             <p  style="text-decoration:underline;text-transform: capitalize" class="p-0 mb-1 mplus2p-m spacing1-2 noiseblack">{{item.position_overview ? item.position_overview : ''}}</p>
                          </div>
                        <div class="row">
                          <div class="col-md-2 pr-0" style="padding-left:40px">
                          <p class="p-0 mb-1 mplus2p-m spacing1-2 noiseblack">{{$t('past_job_period')}} </p>

                          </div>
                          <div class="col-md-10 pl-0">
                              <p class="p-0 mb-1 mplus2p-m spacing1-2 noiseblack">{{item.started_at ? startDate(item.started_at) : ''}} ~ {{item.ended_at ? endDate(item.ended_at) : ''}}</p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-2 pr-0" style="padding-left:40px">
                             <p  class="p-0 mb-1 mplus2p-m spacing1-2 noiseblack ">{{$t('past_job_details')}}  </p>
                          </div>
                          <div class="col-md-10 pl-0">
                            <p  class="p-0 mb-1 mplus2p-m spacing1-2 noiseblack jobDetailDesc">{{item.responsibility ? item.responsibility : ''}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- <template v-if="engineer_role_to_handle != null">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('role_to_handle')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">{{engineer_role_to_handle}}</p>
                  </div>
                </template> -->
              </div>
            </div>
            <div class="row eview" id="score_info">
              <div class="col-md-12 pv_showchart">
                <div class="row">
                  <div class="col-md-4 text-center" style="border-right: 1px solid #e1e1e1;">
                    <p class="cocogothic spacing3-2  spacing3-2 noiseblack statustitle text-center">
                      {{$t('sk_total_lb')}}</p>
                    <div class="chartboxes">
                      <h3 class="mplus2p-r noiseblack statusnum" id="total">{{model.total}}</h3>
                    </div>
                  </div>
                  <div class="col-md-4 text-center" style="border-right: 1px solid #e1e1e1;">
                    <p class="cocogothic spacing3-2 noiseblack statustitle text-center">{{$t('sk_technical_lb')}}</p>
                    <div class="chartboxes">
                      <h3 class="mplus2p-r noiseblack statusnum" id="technical">{{model.technical}}</h3>
                    </div>
                  </div>
                  <div class="col-md-4 text-center">
                    <p class="cocogothic spacing3-2 noiseblack statustitle">{{$t('sk_management_lb')}}/{{$t('sk_business_lb')}}</p>
                    <div class="chartboxes">
                      <h3 class="mplus2p-r noiseblack statusnum" id="management">{{model.management}}</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row slide_options">
                <div class="col-md-6 slide_item spressed wrapper2" id="p1" @click="pressed_slide_skill(1)">
                  <span class="slide_txt mplus2p-r spacing1-4">{{$t('sk_technical_lb')}}</span>
                </div>
                <div class="col-md-6 slide_item wrapper2" id="p2" @click="pressed_slide_skill(2)">
                  <span class="slide_txt mplus2p-r spacing1-4">{{$t('sk_management_lb')}}/{{$t('sk_business_lb')}}</span>
                </div>
              </div>
              <div id="technical_info">
                <div class="col-md-12 text-right">
                      <div class="dropdown">
                        <a href="javascript:void(0)" class="nav-link blue" data-toggle="dropdown">
                          <span class="addlinks mplus2p-m spacing1-2 blue">{{$t('about_defination')}}</span>
                        </a>
                      <div class="notification-container custom-popup dropdown-menu dropdown-menu-right"  aria-labelledby="dropdownMenuButton">
                          <p class="text-center"><strong>{{$t('description_of_definitions')}} </strong><button type="button" class="close" data-dismiss="modal" style="color: #3d7dd8;">&times;</button></p>
                          <hr class="cline">
                          <div class="pl-3 pr-3 ">
                              <p><strong>{{$t('definition_of_choice')}}</strong></p>
                              <p><span class="text-danger">{{$t('no_experience')}}</span> {{$t('no_experience_desc')}}<span></span> </p>
                              <p><span class="text-danger">{{$t('experienced')}}</span> {{$t('experienced_desc')}}<span></span> </p>
                              <p><span class="text-danger">{{$t('no_confidence')}}</span> {{$t('no_confidence_desc')}}<span></span> </p>
                              <p><span class="text-danger">{{$t('confident')}}</span> {{$t('confident_desc')}}<span></span> </p>
                              <p><span class="text-danger">{{$t('very_confident')}}</span> {{$t('very_confident_desc')}}<span></span> </p>
                              <p><span class="text-danger">{{$t('know')}}</span> {{$t('know_desc')}}<span></span> </p>
                              <p><span class="text-danger">{{$t('implement')}}</span> {{$t('implement_desc')}}<span></span> </p>
                              <p><span class="text-danger">{{$t('set')}}</span> {{$t('set_desc')}}<span></span> </p>
                              <p><span class="text-danger">{{$t('build')}}</span> {{$t('build_desc')}}<span></span> </p>
                              <p><strong>{{$t('defination_intention')}}</strong></p>
                              <p><span class="text-danger">{{$t('occurred')}}</span> {{$t('occurred_desc')}}<span></span> </p>
                              <p><span class="text-danger">{{$t('catch_up_technique')}}</span> {{$t('catch_up_technique_desc')}}<span></span> </p>
                              <p><span class="text-danger">{{$t('choose_technique')}}</span> {{$t('choose_technique_desc')}}<span></span> </p>
                          </div>
                      </div>
                    </div>
                </div>
                <div class="col-md-12 pv_showchart">
                  <div class="row">
                    <div class="col-md-12 skillUpdate">
                      <div class="skillUpdate row">
                        <div v-if="skills.length > 0" class="col-md-12">
                          <div v-for="(skill, index) in skills" :key="index">
                            <div class="border-3" v-for="(question, index) in skill.Technical" :key="index">
                              <div v-if="question.name">
                                <h2 class="" style="text-align:left">
                                  {{lan == 'en' ? question.name : question[0]}} </h2>
                                  <div v-if="question.name" >
                                    <div class="tech2" v-for="(level, index) in question" :key="index">
                                      <span v-if="index != 0 && level.name" class="sub-layer2">{{lan == 'en' ? level.name : level.jp_name }}</span>
                                      <span class="layer2" v-if="index != 0 && level.answer">{{level.answer}}</span>
                                      <span class="layer2" v-for="(item, index) in level.skill" :key="index">{{lan == 'en' ? item.check_content : item.jp_check_content }}</span>
                                    </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else class="col-md-12">
                          <div class="col-md-12 alert alert-danger text-center">
                            <strong>{{$t('err_skill_not_found')}}</strong>
                          </div>
                        </div>
                      </div>
                      <div v-if="skillLoader" class="d-block text-center w-100">
                            <i class="fa fa-spinner fa-4x fa-spin" style="color:#3d7dd8"></i>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="management_info">
                <div class="col-md-12 text-right">
                      <div class="dropdown">
                        <a href="javascript:void(0)" class="nav-link blue" data-toggle="dropdown">
                          <span class="addlinks mplus2p-m spacing1-2 blue">{{$t('about_defination')}}</span>
                        </a>
                      <div class="notification-container custom-popup dropdown-menu dropdown-menu-right"  aria-labelledby="dropdownMenuButton">
                          <p class="text-center"><strong>{{$t('description_of_definitions')}}</strong> <button type="button" class="close" data-dismiss="modal" style="color: #3d7dd8;">&times;</button></p>
                          <hr class="cline">
                          <div class="pl-3 pr-3 ">
                              <p><strong>{{$t('definition_of_skill')}}</strong></p>
                              <p><span class="text-danger">{{$t('pmo')}}</span> {{$t('pmo_desc')}}<span></span> </p>
                              <p><strong>{{$t('definition_of_choice')}}</strong></p>
                              <p><span class="text-danger">{{$t('have_knowledge')}}</span> {{$t('have_knowledge_desc')}}<span></span> </p>
                              <p><span class="text-danger">{{$t('pay_attention')}}</span> {{$t('pay_attention_desc')}}<span></span> </p>
                              <p><span class="text-danger">{{$t('have_know')}}</span> {{$t('have_know_desc')}}<span></span> </p>
                              <p><span class="text-danger">{{$t('management_experienced')}}</span> {{$t('management_experienced_desc')}}<span></span> </p>
                              <p><span>{{$t('in')}}</span><span class="text-danger">{{$t('in_desc1')}}</span> {{$t('in_desc2')}}<span></span> </p>
                              <p><strong>{{$t('what_i_want')}}</strong></p>
                              <p><span class="text-danger">{{$t('member_growing_up')}}</span> {{$t('member_growing_up_desc')}}<span></span> </p>
                              <p><span class="text-danger">{{$t('team_member')}}</span> {{$t('team_member_desc')}}<span></span> </p>
                              <p><span class="text-danger">{{$t('bussiness_will_taken')}}</span> {{$t('bussiness_will_taken_desc')}}<span></span> </p>
                          </div>
                      </div>
                    </div>
                </div>
                <div class="col-md-12 pv_showchart">
                  <div class="row">
                    <div class="col-md-12 skillUpdate">
                      <div class="skillUpdate row">
                        <div v-if="skills != []" class="col-md-12">
                          <div v-for="(skill, index) in skills" :key="index">
                            <div class="border-3" v-for="(question, index) in skill.Management" :key="index">
                              <div v-if="question.name">
                                <h2 class="" style="text-align:left">
                                  {{lan == 'en' ? question.name : question[0]}}</h2>
                                <div class="tech2" v-for="(level, index) in question" :key="index">
                                  <span v-if="index != 0 && level.name" class="sub-layer2">{{lan == 'en' ? level.name : level.jp_name}}</span>
                                  <span class="layer2" v-if="index != 0 && level.answer">{{level.answer}}</span>
                                  <span class="layer2" v-for="(item, index) in level.skill" :key="index">{{lan == 'en' ? item.check_content : item.jp_check_content }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else class="col-md-12">
                          <div class="col-md-12 alert alert-danger text-center">
                            <strong>{{$t('err_skill_not_found')}}</strong>
                          </div>
                        </div>
                        <div v-if="skillLoader" class="d-block text-center w-100">
                            <i class="fa fa-spinner fa-4x fa-spin" style="color:#3d7dd8"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hashids from "hashids";
import axios from "axios";
import NavSidebar from "./company_sidebar";
import { EventBus } from "../../main.js";

export default {
  data() {
    return {
      skillLoader: false,
      loading: false,
      userId: "",
      engineer_desc: "",
      engineer_firstname: "",
      engineer_lastname: "",
      engineer_id: "",
      engineer_initials: "",
      engineer_bday: "",
      engineer_sex: "",
      engineer_location: [],
      engineer_required_work_area_to_be: [],
      engineer_decs_emp_con: "",
      engineer_desc_emp_from: "",
      engineer_income_type: '',
      engineer_income: '',
      engineer_policy: "",
      engineer_email: "",
      engineer_image: "",
      engineer_video: "",
      engineer_experience: "",
      engineer_national: [],
      engineer_current_position: "",
      engineer_current_type_of_contract: [],
      engineer_required_position: "",
      engineer_requried_type_of_contract: [],
      engineer_languages: [],
      engineer_company_name: "",
      engineer_expertise: "",
      engineer_favorited: '',
      enginner_job_seeking: '',
      engineer_role_to_handle: '',
      engineer_past_job_details: [],
      engineer_manager_comments: '',
      engineer_want_to_talk_casually: '',
      engineer_last_login: '',
      engineer_verified: '',
      engineer_pdf: [],

      companyUserId: "",

      panelId: 1,
      skillPanelId: 1,

      skills: [],

      model: {},
      lan: "jp",
      testUser: 0
    };
  },
  components: {
    appEEngineerSidenav: NavSidebar
  },
  created() {
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
    if (localStorage.getItem("role") == "company_user") {
      var retrievedData = localStorage.getItem("user");
      var data = JSON.parse(retrievedData);
      this.companyUserId = data.id;
       this.testUser = data.test_user;
      var hashids = new Hashids("EngineerIds", 8, "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890")
      var engineerId = hashids.decode(this.$route.params.uid)

      this.userId = engineerId;
      if (engineerId.length == 0) {
        return this.$router.push("/global/PageNotFound")
      }
      this.engineerProfile(this.userId);
    }
    else{
      return this.$router.push("/global/PageNotFound");
    }
  },
  mounted() {
    this.doCenter();
    this.pressed_slide(this.panelId);
    this.pressed_slide_skill(this.skillPanelId);
    EventBus.$on("language", data => {
      this.lan = data;
    });
  },
  computed: {
    onResize(event) {
      this.doCenter();
    }
  },
  methods: {
    dateFormate(date){
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
    startDate(date){
      return moment(date).format('YYYY/MM')
    },
    endDate(date){
      return moment(date).format('YYYY/MM')
    },
    sandMsg(uid) {
      var hashids = new Hashids("this is my salt", 8, "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890");
      this.$router.push("/global/chatroom/"+ hashids.encode(uid));
    },
    downloadFile(path){
      axios({
        url: "/file/resume/"+ path +"?token=" + localStorage.getItem("token"), //your url
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', path); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
     onFavClick(id) {
      let user = localStorage.getItem("user");
      var token = localStorage.getItem("token");
      var vm = this;
      const formData = {
        user_id: id
      };
      this.engineer_favorited = !this.engineer_favorited;
      this.$forceUpdate();
      axios
        .post("/favorite/engineer?token=" + token, formData, {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
            if (res.data.data.message) {
              this.$toaster.error(res.data.data.message);
            }
            this.engineer_favorited = !this.engineer_favorited;
            this.$forceUpdate();
          } else {
            if (res.data.liked) {
              this.$toaster.success(vm.$t("success_engineer_favorited"));
            } else {
              this.$toaster.error(vm.$t("err_engineer_favorited"));
            }
          }
        });
    },
    getScore(skillPanalId) {
      this.skillLoader = true;
      axios
        .get("/user-skill-items/"+ this.userId + "?token=" + localStorage.getItem("token"))
        .then(res => {
          this.model.total = res.data.total;
          this.model.technical = res.data.technical_total;
          this.model.management = res.data.other_total;
          if (res.data.skills != null) {
            // var skills = res.data.skills.sort(function(a, b) {
            //   return a.id - b.id;
            // });
            this.skills = res.data.skills
            if(skillPanalId == 1){
              let arr = [];
              for (let item in this.skills[0].Technical) {
                let obj = this.skills[0].Technical[item];
                obj.name = item;
                arr.push(obj);
              }
              arr.sort((a, b) => {
                return a[1].subcategory_id - b[1].subcategory_id;
              });
              this.skills[0].Technical = arr
            }
            if(skillPanalId == 2){
              this.skills  = res.data.skills;
                let arr2 = [];
                for (let item2 in this.skills[0].Management) {
                  let obj = this.skills[0].Management[item2];
                  obj.name = item2;
                  arr2.push(obj);
                }
                arr2.sort((a, b) => {
                  return a[1].subcategory_id - b[1].subcategory_id;
                });
                this.skills[0].Management = arr2
            }
          this.skillLoader = false;
          }
        })
        .catch(error => {
          this.loading = false;
        });
      this.$forceUpdate();
    },
     urlify(text) {
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      //var urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, function(url,b,c) {
          var url2 = (c == 'www.') ?  'http://' +url : url;
          return '<a href="' +url2+ '" target="_blank">' + url + '</a>';
      })
    },
    engineerProfile(engineerId) {
      this.loading = true;
      axios
        .get("/engineer-detail/" + engineerId + "?token=" + localStorage.getItem("token"), {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
            if(res.data.errors){
                this.$toaster.error(res.data.errors[0].message);
                this.$router.push("/global/PageNotFound");
            }
            this.loading = false;
          } else {
            this.image = res.data.user.image;
            this.engineer_desc = res.data.user.career_summary;
            if (res.data.user.last_name) {
              this.engineer_lastname = res.data.user.last_name;
            }

            if (res.data.user.first_name) {
              this.engineer_firstname = res.data.user.first_name;
            }

            this.engineer_id = res.data.user.id;
            this.engineer_initials = res.data.user.initials;
            this.engineer_email = res.data.user.email;
             if (res.data.user.image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
                this.engineer_video = res.data.user.image;
              }else{
                this.engineer_image = res.data.user.image;
              }
            this.engineer_last_login = res.data.user.last_login_time;
             var today = new Date();
            var birthDate = new Date(res.data.user.birthdate);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
              age--;
            }
            this.engineer_bday = age;
            try {
              this.engineer_sex = res.data.user.gender
                ? res.data.user.gender
                : "";
              this.engineer_location = res.data.user.location;
              this.engineer_required_work_area_to_be =
                res.data.user.required_work_area_to_be;
              this.engineer_decs_emp_con = res.data.user.current_position;
              this.engineer_desc_emp_from =
                res.data.user.current_type_of_contract;
              this.engineer_income_type = res.data.user.income_type_id;
              this.engineer_income = res.data.user.income.toLocaleString();
              this.engineer_policy = res.data.user.policy;
              this.engineer_experience = res.data.user.experience;
              this.engineer_national = res.data.user.national;
              this.engineer_current_position = res.data.user.current_position;
              this.engineer_pdf = res.data.user.resumes;
              this.enginner_job_seeking = res.data.user.job_seeking_situation;
              this.engineer_expertise = res.data.user.expertise;
              this.engineer_favorited = res.data.user.favorited;
              this.engineer_past_job_details = res.data.user.past_job_details;
              this.engineer_manager_comments = res.data.user.manager_comments;
              this.engineer_want_to_talk_casually = res.data.user.want_to_talk_casually;
              this.engineer_current_type_of_contract =
                res.data.user.current_type_of_contract;
              this.engineer_required_position = res.data.user.required_position;
              this.engineer_requried_type_of_contract =
                res.data.user.required_type_of_contract;
              this.engineer_languages = res.data.user.languages;
              this.engineer_verified = res.data.user.verified;
              this.engineer_role_to_handle = res.data.user.role_to_handle;
            } catch (error) {}

            this.loading = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    doCenter() {
      let txtheight, txtwidth;
      if ($(window).width() <= 975 && $(window).width() >= 751) {
        $("#total").css("font-size", "1rem");
        $("#technical").css("font-size", "1rem");
        $("#management").css("font-size", "1rem");
        $("#business").css("font-size", "1rem");
        txtwidth = [10.44, 20.88, 31.3];
        txtheight = 40;
      } else {
        $("#total").css("font-size", "1.5rem");
        $("#technical").css("font-size", "1.5rem");
        $("#management").css("font-size", "1.5rem");
        $("#business").css("font-size", "1.5rem");
        txtwidth = [15.66, 31.3, 46.95];
        txtheight = 28;
      }
    },
    pressed_slide(id) {
      this.panelid = id;
      $(".wrapper1").removeClass("spressed");
      $("#s" + id).addClass("spressed");
      if (this.panelid === 1) {
        $("#basic_info").css("display", "flex");
        $("#score_info").css("display", "none");
      }
      if (this.panelid === 2) {
        $("#score_info").css("display", "block");
        $("#basic_info").css("display", "none");
        this.doCenter();
      }
    },
    pressed_slide_skill(id) {
      this.skillPanelid = id;
      $(".wrapper2").removeClass("spressed");
      $("#p" + id).addClass("spressed");
      if (this.skillPanelid === 1) {
        $("#technical_info").css("display", "block");
        $("#management_info").css("display", "none");
         this.getScore(this.skillPanelid);
      }
      if (this.skillPanelid === 2) {
        $("#management_info").css("display", "block");
        $("#technical_info").css("display", "none");
         this.getScore(this.skillPanelid);
        this.doCenter();
      }
    }
  }
};
</script>

<style scoped>
.casually{
  background: #3f7ed8;
  color: white;
  padding: 10px;
  border-radius: 6px;
  float: right;
  margin-right: 15px
}
.casually::after{
    content: '';
    position: absolute;
    right: 122px;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-left-color: #3f7ed8;

}
.comment-block{
  width: 100%;
  border: 2px solid #3f7ed8;
  padding: 10px 25px 10px 25px;
  border-radius: 20px;
  margin-top: 15px !important;
}
.comment-title{
  color: #3f7ed8;
  font-size: 1rem;
  text-decoration: underline;
  margin-bottom: 5px;
}
.comment-desc{
 white-space: pre-line;
  word-break: break-all;
  font-size: 1rem;
  margin: 0;
  color: #3f7ed8;
}
.jobDetailDesc{
  white-space:pre-wrap;
  text-align: justify !important;
   font-size: 1rem;
  margin-right: 20px !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
   text-overflow: ellipsis;
   word-wrap: break-word;
  display: -webkit-box;

}
.jobDetail p{
  color: #b3b2ab;
  font-weight: 400 !important;
}
.jobDetail{
  background-color: #F2F2F2;
  padding: 10px;
  margin-bottom: 20px;
  text-align: justify
}
.rc_firsttitle {
    font-size: 1.5rem;
    font-weight: 500;
}
.text-danger{
  background-color: #eeeeee;
}
.close{
  padding-right: 25px;
}
.addlinks{
  margin-top: 10px;
  background-color: #dae8ff;
  padding:15px;
  border-radius: 30px;
}
.addlinks:hover{
text-decoration: underline;
  cursor: pointer;
}
.nav-link {
    margin-right: -30px;
      margin-top: 15px;
}
.clickcbtn {
  border-radius: 20px;
  padding: 7px 14px;
  box-shadow: 0 1px 4px 0 rgba(40, 60, 80, 0.4);
  float: right;

}
.cline{
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 2px solid rgba(0,0,0,.1);
}
.skillUpdate {
  padding-top: 10px;
  padding-bottom: 20px;
}

.tech2 {
  margin-right: 5px;
  margin-bottom: 10px;
}

.layer2 {
  border: 2px solid #3d7dd8;
  font-size: 0.7rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.4px;
  color: #3d7dd8;
  padding: 5px;
  margin-right: 5px;
  white-space: pre;
  word-break: keep-all;
  display: inline-block;
  border-radius: 5px;
  margin-bottom: 10px;
}

.sub-layer2 {
  width: fit-content;
  background-color: #3d7dd8;
  font-size: 0.7rem;
  text-align: center;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.4px;
  color: #fff;
  padding: 8px;
  margin-right: 5px;
  margin-bottom: 10px;
  border-radius: 50px;
  display: block;
}
.pman {
  width: 120px;
  margin-top: 70px;
}

.slide_options {
  background-color: #f8fafa;
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 25px;
  padding: 5px 0px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
  width: 80%;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
  padding-left: 40px;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 21px;
  word-wrap: break-word;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  margin-top: 35px;
  max-width: 200px;
}

.statustitle {
  font-size: 1.20rem;
  font-weight: bold;
  margin-top: 34px;
  height: 50px;
  margin-bottom: 0.1rem;
}

.statusnum {
  top: 55%;
  font-weight: bold;
  font-size: 3rem !important;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.custom-wrapper {
  /* width: 423px; */
  max-height: 250px;
  overflow: auto;
}
.like .fa {
  color: #fc033b;
  text-shadow: 1px 1px 1px #ccc;
}
@media screen and (max-width: 768px) {
  .pman {
    margin-top: 0px;
  }

  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }
}
</style>
